export const EstadoEntrevista = Object.freeze({
    PENDIENTE: "PENDIENTE",
    REALIZADO: "REALIZADO", 
    NO_ASISTIO:"NO_ASISTIO",
});